import { render, staticRenderFns } from "./BalanceMovesHeader.vue?vue&type=template&id=1a0b1448&"
import script from "./BalanceMovesHeader.vue?vue&type=script&lang=ts&"
export * from "./BalanceMovesHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceMovesHeader.vue?vue&type=style&index=0&id=1a0b1448&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports